export default {
    inserted(el) {
        setTimeout(() => {
            el.focus(el);
        });
    },
};
